module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classifydetails"
  }, [_c('div', {
    staticClass: "classifydetails-topBar"
  }, [_c('div', {
    staticClass: "classifydetails-topNav"
  }, [_c('div', {
    staticClass: "classifydetails-topNav-left"
  }, [_c('div', {
    staticClass: "classifydetails-backBox",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "classifydetails-titleBox"
  }, [_c('span', {
    staticClass: "classifydetails-title"
  }, [_vm._v(_vm._s(_vm.$route.params.classifydetailsTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "classifydetails-topNav-right"
  }, [_c('div', {
    staticClass: "classifydetails-homeBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "classifydetails-personalBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/login"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-person",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "classifydetails-container"
  }, [_c('ul', _vm._l((_vm.classifydetailsList), function(item) {
    return _c('li', [_c('div', {
      staticClass: "classifydetails-img"
    }, [_c('router-link', {
      attrs: {
        "exact": "",
        "to": '/bookdetails/' + item.title + '&' + _vm.catalogId
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "classifydetails-info"
    }, [_c('p', {
      staticClass: "classifydetails-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "classifydetails-sub1"
    }, [_vm._v(_vm._s(item.sub1))]), _vm._v(" "), _c('p', {
      staticClass: "classifydetails-sub2",
      domProps: {
        "innerHTML": _vm._s('★简介★' + item.sub2)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "classifydetails-subTag"
    }, [_c('span', {
      staticClass: "classifydetails-tags"
    }, [_vm._v(_vm._s(item.tags))]), _vm._v(" "), _c('span', {
      staticClass: "classifydetails-reading"
    }, [_vm._v(_vm._s(item.reading))]), _vm._v(" "), _c('span', {
      staticClass: "classifydetails-bytime"
    }, [_vm._v(_vm._s(item.bytime))])])])])
  }))]), _vm._v(" "), _c('classifydetails-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-373a01a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/classifydetails/index.vue
// module id = 184
// module chunks = 1